import React from 'react';
import MedicalRecordStatusBadge from 'components/MedicalRecordStatusBadge/MedicalRecordStatusBadge';
import useDocumentPromotion from 'modules/FileManagerV2/hooks/api/useDocumentPromotion';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { isPersonalInjuryPracticeArea } from 'utils/isPersonalInjuryPracticeArea';
import PromotionLogPanel from './PromotionLogPanel';

/**
 * Renders promotion badge and audit log for the active preview file.
 * Hidden when the current matter is not Personal Injury.
 * @param {{ item: object|null }} props
 */
const PreviewMedicalRecordSection = ({ item }) => {
  const { caseDetails } = useFileManagerContext();
  const fileId = item?.file_id || item?.object_id;
  const isFile = item && item.entry_type !== 'folder';
  const showPromotionUi = isPersonalInjuryPracticeArea(caseDetails);

  const { promotionStatus, promotedAt, promotionSource, promotionLog } = useDocumentPromotion(fileId, {
    enabled: showPromotionUi && !!fileId && isFile,
  });

  if (!showPromotionUi || !isFile || !fileId) {
    return null;
  }

  return (
    <div className="preview-medical-record-section px-3 py-2" data-testid="preview-medical-record-section">
      <div className="mb-2" data-testid="preview-medical-record-badge">
        <MedicalRecordStatusBadge status={promotionStatus} promotedAt={promotedAt} promotionSource={promotionSource} />
      </div>
      <PromotionLogPanel promotionLog={promotionLog} />
    </div>
  );
};

export default PreviewMedicalRecordSection;
